import { TargetLanguage } from "./target-language";

export const LANGUAGES: TargetLanguage[] = [
    { id: 1, name: "dutch"},
    { id: 2, name: "english"},
    { id: 3, name: "french"}
]